module.exports = __webpack_public_path__ + "img/chrome.8e86715a.svg";